import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-P",
  "use": "deviceData-P-usage",
  "viewBox": "0 0 8 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 11\" id=\"deviceData-P\"><path d=\"M1.6 10.8V6.5h2.6c1.1 0 2-.3 2.7-.9s.9-1.4.9-2.3c0-1-.3-1.7-.9-2.3S5.4.1 4.2.1H.1v10.7h1.5zm2.6-5.4H1.6V1.3h2.6c.7 0 1.3.2 1.6.6s.5.9.5 1.5-.2 1.1-.5 1.5-.8.5-1.6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-P.svg
// module id = tzqx
// module chunks = 6